import SidebarItem from "./SidebarItem";
import documentImg from "../assets/images/noteicn.svg";
import useImg from "../assets/images/profile_2user.svg";
import settingImg from "../assets/images/setting-2.svg";
import newlogo_icn from "../assets/images/newlogoicn.svg";
import docomatic_logo from "../assets/images/textlogo_bet.svg";
import helpButton from "../assets/images/help.svg";
import $ from "jquery";

import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { clearSession } from "../utils/localSession";
import { useContext, useEffect, useState } from "react";
import { SocketContext } from "../socket/socket";
import { useDispatch } from "react-redux";
import logoutImg from "../assets/images/logoutNEW.svg";
import { logoutData } from "../features/auth/logout/logoutSlice";
import { OK } from "../constants/statusCode";
/* import RoleContext from "../context/roleContext"; */
import { getProfileData } from "../features/profile-management/getProfileDataSlice";

/* import categoryImg from "../assets/images/element_plus.svg"
import reportImg from "../assets/images/status_up.svg"; */
const sideBarList = [
  {
    activeLinks: ["/dashboard"],
    image: documentImg,
    link: "/dashboard",
    title: "Documents",
  },
  {
    activeLinks: ["/manageusers"],
    image: useImg,
    link: "/manageusers",
    title: "Users",
  },
  {
    activeLinks: ["/settings"],
    image: settingImg,
    link: "/settings",
    title: "Setting",
  },
];
/* {
  activeLinks: ["/categories"],
  image: categoryImg,
  link: "#",
  title: "Categories",
},
{
  activeLinks: ["/reports"],
  image: reportImg,
  link: "#",
  title: "Reports",
}, */

const Sidebar = () => {
  const socketContext = useContext(SocketContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [newList, setNewList] = useState([]);

  let projectData = JSON.parse(localStorage.getItem("_user"));

  const handleHelpButtonClick = () => {
    var Intercom = (window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      alignment: "left",
      hide_default_launcher: true,
    });
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/mv90ybvo";
          var x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
          l();
        } else if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();
    $(".timeline-wrap .intercom-lightweight-app").addClass("d-none");
    window.Intercom("show");
  };

  /**
   * logout function
   */
  const handleLogout = async () => {
    const { payload } = await dispatch(logoutData());
    if (payload.status === OK) {
      clearSession();
      navigate("/login");
    }
    socketContext.socket.disconnect("disconnect", () => {});
  };

  useEffect(() => {
    dispatch(getProfileData(projectData?.organizations[0]?.uuid)).then(
      (data, index) => {
        data?.payload?.data?.responseData?.permission.length > 0 &&
          data?.payload?.data?.responseData?.permission.forEach(
            (nData, index) => {
              if (nData.name === "Users" && nData.Permissions.length <= 0) {
                let filterData = sideBarList.filter(
                  (data, index) => data.title !== "Users"
                );
                setNewList(filterData);
              } else {
                if ((nData.name === "Users" || nData.name === "Roles") && nData.Permissions.length > 0) {
                  setNewList(sideBarList);
                }
              }
            }
          );
      }
    );
  }, []);

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-logo">
          <Link to="/dashboard" className="brand-logo">
            <img
              className="brand-logo-img"
              src={newlogo_icn}
              alt="brand_logo.svg"
            />
            {/* <p className="brand-logo-txt">
                CloudTutorial
                <sup className="sup-txt">+AI</sup>
              </p> */}
            <div className="brand-logo-txt-img">
              <img src={docomatic_logo} alt="docomatic_logo" />
            </div>
          </Link>
        </div>
        <div className="sidebar-nav">
          {newList.map((sidebarItem, sidebarIndex) => (
            <SidebarItem
              activeLinks={sidebarItem.activeLinks}
              image={sidebarItem.image}
              link={sidebarItem?.link}
              title={sidebarItem.title}
              key={sidebarIndex}
              subMenu={sidebarItem?.subMenu}
            />
          ))}
          <ul>
            <li>
              <div
                className="nav-link logout-link"
                onClick={() => handleLogout()}
              >
                <img
                  className="dropdown-item-img"
                  src={logoutImg}
                  alt="logout"
                />

                <span className="nav-link-txt">Logout</span>
              </div>
            </li>
          </ul>
          <ul className="help-intercom">
            <li>
              <div className="nav-link" onClick={() => handleHelpButtonClick()}>
                <img className="nav-link-icn" src={helpButton} />
                <span className="nav-link-txt">Chat with us</span>
              </div>
            </li>
         {/*    <Helmet>
              <script src="http://127.0.0.1:5500/script.js"></script>
            </Helmet> */}
          </ul>
        </div>
        {/* <div className="user-menu">
                    <div className="dropdown  dropend">
                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={ejImg} alt="ej_img" />
                        </button>
                        <ul className="dropdown-menu" data-popper-placement="right-start">
                            <li><a className="dropdown-item" href="#">
                                <p>Emily Jakson</p>
                                <span>Invoicewol</span>
                            </a></li>
                            <li><a className="dropdown-item" href="#"><img className="dropdown-item-img" src={plusicnImg} alt="plusicn" />Another action</a></li>
                            <li><a className="dropdown-item" href="#"><img className="dropdown-item-img" src={logoutImg} alt="logout" />Something else here</a></li>
                        </ul>
                    </div>
                </div> */}
      </div>
    </>
  );
};

export default Sidebar;
